import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/screenings", label: "AAN Events" },
  { to: "/tickets", label: "My Tickets" },
  { to: "/login", label: "Sign In" },
];

function navLinkClass(isActive: boolean) {
  return `border-l border-white/35 px-4 py-2 font-display text-[12px] font-semibold uppercase leading-none transition-colors hover:text-aan-bright ${
    isActive ? "text-aan-bright" : "text-white"
  }`;
}

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/95 text-white shadow-[0_20px_60px_rgba(0,0,0,0.45)] backdrop-blur">
      <div className="mx-auto flex h-24 max-w-7xl items-center justify-between px-4 sm:px-8 lg:h-28">
        <Link to="/" className="flex items-center" aria-label="African Art Network home">
          <img
            src="/assets/logo-white.png"
            alt="African Art Network"
            className="h-auto w-28 sm:w-36 lg:w-44"
          />
        </Link>

        <div className="hidden items-center lg:flex">
          {navLinks.map((link) => (
            <NavLink key={link.to} to={link.to} className={({ isActive }) => navLinkClass(isActive)}>
              {link.label}
            </NavLink>
          ))}
          <Link
            to="/screenings"
            className="ml-4 rounded-full bg-aan-green px-6 py-2.5 font-display text-[12px] font-black uppercase text-white transition hover:bg-aan-bright hover:text-black"
          >
            Buy Tickets
          </Link>
        </div>

        <button
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
          className="inline-flex h-10 w-10 items-center justify-center border border-white/40 bg-black text-white lg:hidden"
          onClick={() => setIsOpen((value) => !value)}
        >
          {isOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {isOpen ? (
        <div className="border-t border-white/10 bg-black px-4 pb-5 lg:hidden">
          <div className="mx-auto max-w-7xl border border-white/15">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `block border-b border-white/10 px-4 py-3 font-display text-xs font-semibold uppercase ${
                    isActive ? "bg-aan-green text-black" : "text-white hover:bg-white/10"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/screenings"
              onClick={() => setIsOpen(false)}
              className="block px-4 py-3 text-center font-display text-xs font-black uppercase text-aan-bright"
            >
              Buy Tickets
            </Link>
          </div>
        </div>
      ) : null}
    </nav>
  );
}
